import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChartExportFacade } from './chart-export.facade';
import { FileExportEffects } from './file-export/file-export.effects';
import * as fromFileExport from './file-export/file-export.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([FileExportEffects]),
    StoreModule.forFeature(fromFileExport.fileExportFeatureKey, fromFileExport.reducer),
  ],
  providers: [ChartExportFacade],
})
export class FileExportsDomainModule {}
